export default __webpack_public_path__ + "static/media/left-post.9e0c9612.svg";